<!--
 * @Author: chj
 * @Date: 2024-10-10 14:49:19
 * @LastEditors: chj
 * @LastEditTime: 2024-10-22 10:25:19
 * @Description: 请填写简介
-->
<template>
  <section :class="bem()">
    <div :class="bem('left')">
      <div :class="bem('header')">
        <h3 :class="bem('header-title')">联盟要闻</h3>
        <router-link to="/dynamic/news">
          <a-button type="link">更多>></a-button>
        </router-link>
      </div>
      <div :class="bem('list')">
        <router-link
          :to="`/list/${item.type}/${item.id}`"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div :class="bem('item')">
            <p :class="bem('item-title')">{{ item.main_title }}</p>
            <span :class="bem('item-time')" v-if="item.release_date">{{
              parseTime(item.release_date, "{y}-{m}-{d}")
            }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div :class="bem('right')">
      <div :class="bem('header')">
        <h3 :class="bem('header-title')">会员资讯</h3>
        <router-link to="/dynamic/information">
          <a-button type="link">更多>></a-button>
        </router-link>
      </div>
      <div :class="bem('list')">
        <router-link
          :to="`/list/${item.type}/${item.id}`"
          v-for="(item, index) in informationList"
          :key="index"
        >
          <div :class="bem('item')">
            <p :class="bem('item-title')">{{ item.main_title }}</p>
            <span :class="bem('item-time')" v-if="item.release_date">{{
              parseTime(item.release_date, "{y}-{m}-{d}")
            }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { Button as AButton } from "ant-design-vue";
import { getDynamic } from "@/api/cms/dynamic";
import { parseTime } from "@/utils/ruoyi";
export default {
  name: "article-detail",
  components: {
    AButton,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 5,
      },
      newsList: [],
      informationList: [],
    };
  },
  methods: {
    parseTime(time, options) {
      return parseTime(time, options);
    },
    async initNews() {
      try {
        const query = {
          type: 14,
          ...this.queryParams,
        };
        const res = await getDynamic(query);
        if (res.code == 0) {
          this.newsList = res.data.list;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    async initInformation() {
      try {
        const query = {
          type: 21,
          ...this.queryParams,
        };
        const res = await getDynamic(query);
        if (res.code == 0) {
          this.informationList = res.data.list;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
  },
  mounted() {
    this.initNews();
    this.initInformation();
  },
};
</script>

<style lang="scss" scoped>
.article-detail {
  display: flex;
  width: 100%;
  margin: 0 auto 80px;
  @include devices(laptop) {
    padding: 0 40px;
  }
  @include devices(pad) {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
  &__left {
    width: 50%;
    padding-right: 100px;
    @include devices(pad) {
      width: 100%;
      padding-right: 0;
    }
  }
  &__right {
    width: 50%;
    padding-left: 100px;
    @include devices(pad) {
      margin-top: 40px;
      width: 100%;
      padding-left: 0;
    }
  }
  &__header {
    display: flex;
    justify-content: space-between;
    &-title {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 40px;
      line-height: 32px;
      color: #ff6900;
      font-size: 24px;
      text-align: center;
      &::after {
        position: absolute;
        content: "";
        bottom: 0px;
        width: 84px;
        height: 4px;
        background-color: rgba(212, 7, 24, 1);
      }
    }
  }
  &__list {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  &__item {
    width: 100%;
    height: 40px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-title {
      flex: 1;
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      cursor: pointer;
      &:hover {
        color: #ff6900;
      }
      &:active {
        color: #ff6900;
      }
    }
    &-time {
      margin-left: 20px;
      flex-shrink: 0;
      color: #919191;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
